import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

// Components
import Button from "../Atoms/Button";
import TrackedCta from "./TrackedCta";

// Constants
import { EVENT_PROPERTIES_VALUES } from "../../types/Amplitude";
import { REST_SHOPIFY_LINK } from "../../utils/restPageConstants";

// Buy button for Rest* product pages
const RestBuyNowButton = ({
  sectionName,
  pageName,
  productName,
  linkProps,
  className,
  children,
}) => {
  const classes = classNames("buy_now_button", className);

  const renderButton = ({ trackOnClick }) => {
    return (
      <Button className={classes} linkProps={linkProps} onClick={trackOnClick}>
        {children}
      </Button>
    );
  };

  return (
    <TrackedCta
      render={renderButton}
      productName={productName}
      buttonText={EVENT_PROPERTIES_VALUES.Buy_Now}
      sectionName={sectionName}
      pageName={pageName}
    />
  );
};

RestBuyNowButton.propTypes = {
  sectionName: PropTypes.string.isRequired,
  pageName: PropTypes.string.isRequired,
  productName: PropTypes.oneOf([
    EVENT_PROPERTIES_VALUES.Rest,
    EVENT_PROPERTIES_VALUES.Rest_Plus,
  ]).isRequired,
  linkProps: PropTypes.object.isRequired,
  trackOnClick: PropTypes.func,
  className: PropTypes.any,
  children: PropTypes.any,
};

RestBuyNowButton.defaultProps = {
  linkProps: {
    href: REST_SHOPIFY_LINK,
  },
  pageName: "Rest Product",
  productName: EVENT_PROPERTIES_VALUES.Rest,
  children: "Buy Now",
};

export default RestBuyNowButton;
